import React from 'react';
import { CircularProgress } from '@material-ui/core';

class Authenticate extends React.Component {
	componentDidMount() {
		const { location, auth } = this.props;
		if (/access_token|id_token|error/.test(location.hash)) {
			auth.handleAuthentication();
		}
	}

	render() {
		return (
			<div
				style={{
					width: '100vw',
					height: '100vh',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<CircularProgress />
			</div>
		);
	}
}

export default Authenticate;
